{
  "buttons": {
    "heading": "Heading",
    "heading_with_level": "Heading {{level}}"
  },
  "tooltips": {
    "bold": "Bold",
    "italic": "Italic",
    "strikethrough": "Strikethrough",
    "link": "Link",
    "unlink": "Unlink",
    "bulletList": "Bullet list",
    "orderedList": "Ordered list",
    "quote": "Quote",
    "clear": "Clear formatting"
  },
  "url_prompt": "Enter link URL:",
  "link_menu": {
    "go_to_link": "Go to link",
    "change": "Change",
    "remove": "Remove"
  }
}
